<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_composition_title' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data">
    <mat-form-field>
      <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
      <mat-select name="transport" [value]="data?.transportId || data?.transports[0]?.resourceId" (selectionChange)="selectTransportChange($event.value)" required>
        <mat-option *ngFor="let t of data.transports" [value]="t.resourceId">{{ t?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'dialog_composition_field_percentage' | translate }}</mat-label>
      <input type="number" matInput [(ngModel)]="data.ratio" name="ratio" min="0" max="100" required />
      <mat-icon matSuffix>%</mat-icon>
      <mat-error *ngIf="!data.ratio" [innerHTML]="'dialog_composition_error_percentage' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
